"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toShellNavigation = void 0;
const lu_1 = require("react-icons/lu");
const icons = {
    LuActivity: lu_1.LuActivity,
    LuBuilding2: lu_1.LuBuilding2,
    LuChartBarBig: lu_1.LuChartBarBig,
    LuClipboardList: lu_1.LuClipboardList,
    LuClock3: lu_1.LuClock3,
    LuMonitorCog: lu_1.LuMonitorCog,
    LuSettings: lu_1.LuSettings,
    LuUsers: lu_1.LuUsers,
};
function toShellNavigation(sections) {
    return sections.map(section => ({
        id: section.code,
        title: section.title,
        items: section.items.map(item => ({
            id: item.code,
            label: item.label,
            href: item.path,
            exact: item.path === '/',
            icon: item.icon ? (icons[item.icon] || lu_1.LuCircle) : lu_1.LuCircle,
        })),
    }));
}
exports.toShellNavigation = toShellNavigation;
//# sourceMappingURL=navigation.js.map